import { useCallback } from 'react'

export function useRedirect() {
  const redirect = useCallback((href: string, target?: '_blank') => {
    const el = document.createElement('a')

    el.href = href
    if (target) {
      el.target = target
    }
    el.click()
    el.remove()
  }, [])

  return redirect
}
